import { SidebarProvider } from "@/components/ui/sidebar";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { router } from "./Routes";
import { TooltipProvider } from "@/components/ui/tooltip";

export default function AppRouterProvider() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <SidebarProvider defaultOpen={false}>
        <TooltipProvider>
          <RouterProvider router={router} />
        </TooltipProvider>
      </SidebarProvider>
    </QueryClientProvider>
  );
}
